module.exports = __webpack_public_path__ + "static/media/rebookDesktopIcon.ab278fb3.svg";